// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"517":"37744c49","2423":"945fb380","5197":"7e02a2e5","6241":"9bb7c1b8","6857":"0bc61ac7"}[chunkId] + ".chunk.css";
};